import React, { useEffect, useState } from "react";

const isHttpUrl = (value) => /^https?:\/\//i.test(value || "");

const withRetryParam = (url, attempt) => {
  try {
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.set("_img_retry", `${Date.now()}-${attempt}`);
    return parsedUrl.toString();
  } catch {
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}_img_retry=${Date.now()}-${attempt}`;
  }
};

const SafeImage = ({
  src,
  fallbackSrc,
  retryCount = 1,
  retryExternal = true,
  alt = "",
  onError,
  ...props
}) => {
  const [currentSrc, setCurrentSrc] = useState(src || fallbackSrc || "");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    setCurrentSrc(src || fallbackSrc || "");
    setAttempt(0);
  }, [src, fallbackSrc]);

  const handleError = (event) => {
    if (onError) {
      onError(event);
    }

    if (src && retryExternal && isHttpUrl(src) && attempt < retryCount) {
      const nextAttempt = attempt + 1;
      setAttempt(nextAttempt);
      setCurrentSrc(withRetryParam(src, nextAttempt));
      return;
    }

    if (fallbackSrc && currentSrc !== fallbackSrc) {
      setCurrentSrc(fallbackSrc);
    }
  };

  return <img {...props} src={currentSrc || fallbackSrc || ""} alt={alt} onError={handleError} />;
};

export default SafeImage;
